var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide","appear":""}},[_c('div',{ref:"container",staticClass:"menu",class:{ 'above-tab-bar': _vm.aboveTabBar }},[(_vm.isAuthenticated && _vm.user)?_c('UserCard',{attrs:{"user-avatar":_vm.user.avatar}}):_c('a',{staticClass:"full-width",attrs:{"href":_vm.$routes.GET_STARTED}},[_c('Banner')],1),_c('MenuItems')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }